// extracted by mini-css-extract-plugin
module.exports = {"registerForm":"styles_registerForm__2k3bG","title":"styles_title__1TLqD","subtitle":"styles_subtitle__8th8f"};